import { render } from "./NameNsDescription.vue?vue&type=template&id=8fec287c&scoped=true"
import script from "./NameNsDescription.vue?vue&type=script&lang=js"
export * from "./NameNsDescription.vue?vue&type=script&lang=js"

import "./NameNsDescription.vue?vue&type=style&index=0&id=8fec287c&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fec287c"]])

export default __exports__